export * from './paths';

export const API_HOST = process.env.REACT_APP_API;
export const API_SOCKET = process.env.REACT_APP_SOCKET_API as string;
